import React, { useEffect } from 'react';
import { find, eq, first, map } from 'lodash';
import { Link } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { SYNC_PAGE_DATA, SET_CLIENT_STATE, CLIENT_STATE } from '../../graphqls';

export default function SyncPageHeader() {
  const { loading: loadingClientState, data: { syncSelectAllDropdown, selectedPage } = {} } = useQuery(CLIENT_STATE);
  const { loading: loadingSyncPageData, data: { syncPageData = [] } = {} } = useQuery(SYNC_PAGE_DATA);
  const [setState] = useMutation(SET_CLIENT_STATE);

  useEffect(() => {
    setState({
      variables: {
        checked: map(syncPageData, ({ id, status }) => ({
          id,
          current: eq(status, 'added') ? ['title', 'description', 'textContent', 'visualTitle', 'visualDescription'] : [],
          sync: eq(status, 'added') ? [] : ['title', 'description', 'textContent', 'visualTitle', 'visualDescription'],
        })),
      },
    });
  }, [syncPageData.length]);

  const onSelect = () => setState({ variables: { syncSelectAllDropdown: !syncSelectAllDropdown } });
  const onSelectAll = ({
    target: {
      dataset: { type },
    },
  }) =>
    setState({
      variables: {
        syncSelectAllDropdown: false,
        checked: map(syncPageData, ({ id, status }) => ({
          id,
          current:
            eq(status, 'added') || (!status && eq(type, 'sync'))
              ? []
              : ['title', 'description', 'textContent', 'visualTitle', 'visualDescription'],
          sync:
            eq(status, 'added') || (!status && eq(type, 'sync'))
              ? ['title', 'description', 'textContent', 'visualTitle', 'visualDescription']
              : [],
        })),
      },
    });
  const onSave = () => setState({ variables: { modalTypeShown: 'saveSync' } });
  const onDelete = () => setState({ variables: { modalTypeShown: 'discardSync' } });
  const currentPage = eq(selectedPage, 'Homepage') ? first(syncPageData) : find(syncPageData, ['id', selectedPage]);
  const currentPageTitle = currentPage ? currentPage.currentData.title || currentPage.currentData.description.replace(/<[^>]+>/g, '') : '';

  if (loadingClientState || loadingSyncPageData || !syncPageData.length) {
    return '';
  }

  return (
    <div className="app-secondary-header sync-secondary-header">
      <span className="current-page">
        <strong>Page:</strong>
        {currentPageTitle}
      </span>
      <Link to="/" className="btn btn-default mint-btn">
        Cancel
      </Link>
      <button type="button" className="btn btn-default mint-btn" onClick={onDelete}>
        Exit &amp; Delete Sync
        <FontAwesomeIcon icon={['fal', 'sign-out']} />
      </button>
      <button type="button" className="btn btn-default mint-btn" onClick={onSave}>
        Overwrite Data
        <FontAwesomeIcon icon={['fal', 'save']} />
      </button>
      <div className="btn-group">
        <button type="button" className="btn btn-default dropdown-toggle mint-btn" onClick={onSelect}>
          Select All
          <FontAwesomeIcon icon={['fal', 'caret-down']} />
        </button>
        {syncSelectAllDropdown && (
          <ul className="dropdown-menu">
            <li>
              <button type="button" data-type="current" onClick={onSelectAll}>
                Current
              </button>
            </li>
            <li>
              <button type="button" data-type="sync" onClick={onSelectAll}>
                New Sync
              </button>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
}
